import { AbstractEvent as s } from "./ghl-ui.es362.js";
class t extends s {
  constructor(r) {
    super(r), this.data = r;
  }
  get dragEvent() {
    return this.data.dragEvent;
  }
}
t.type = "sortable";
class n extends t {
  get startIndex() {
    return this.data.startIndex;
  }
  get startContainer() {
    return this.data.startContainer;
  }
}
n.type = "sortable:start";
n.cancelable = !0;
class a extends t {
  get currentIndex() {
    return this.data.currentIndex;
  }
  get over() {
    return this.data.over;
  }
  get overContainer() {
    return this.data.dragEvent.overContainer;
  }
}
a.type = "sortable:sort";
a.cancelable = !0;
class o extends t {
  get oldIndex() {
    return this.data.oldIndex;
  }
  get newIndex() {
    return this.data.newIndex;
  }
  get oldContainer() {
    return this.data.oldContainer;
  }
  get newContainer() {
    return this.data.newContainer;
  }
}
o.type = "sortable:sorted";
class d extends t {
  get oldIndex() {
    return this.data.oldIndex;
  }
  get newIndex() {
    return this.data.newIndex;
  }
  get oldContainer() {
    return this.data.oldContainer;
  }
  get newContainer() {
    return this.data.newContainer;
  }
}
d.type = "sortable:stop";
export {
  t as SortableEvent,
  a as SortableSortEvent,
  o as SortableSortedEvent,
  n as SortableStartEvent,
  d as SortableStopEvent
};
